import { FileText } from "lucide-react";
import { Template } from "@/types";

interface SelectedTemplateCardProps {
  template: Template;
}

const SelectedTemplateCard = ({ template }: SelectedTemplateCardProps) => {
  const isSystemTemplate = template.isSystem || template.is_system;

  return (
    <div className="flex items-start space-x-3 px-3 py-2 bg-muted border border-border rounded-md">
      <div className="flex flex-col items-center flex-shrink-0">
        <div className="h-6 w-6 text-muted-foreground flex items-center justify-center">
          <FileText size={16} />
        </div>
        <div className="text-xs text-muted-foreground mt-1 text-center">
          {isSystemTemplate ? (
            <span className="bg-blue-100 text-blue-700 text-xs px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap">
              Системный
            </span>
          ) : (
            <span className="bg-green-100 text-green-700 text-xs px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap">
              Польз.
            </span>
          )}
        </div>
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-sm text-foreground font-medium break-words">{template.name}</p>
        {template.description && <p className="text-xs text-muted-foreground mt-1 break-words">{template.description}</p>}
      </div>
    </div>
  );
};

export default SelectedTemplateCard;
